/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Button } from '@/primitives/Button';
import { Container } from '@/primitives/Container';

interface ClientFormActionsProps {
  onCancel: () => void;
  isSubmitting: boolean;
  submitText?: string;
}

export function ClientFormActions({ onCancel, isSubmitting, submitText }: ClientFormActionsProps) {
  const { t } = useMimicTranslation('oauthClients');

  return (
    <Container horizontal gap="sm" style={{ justifyContent: 'flex-end', paddingTop: '8px' }}>
      <Button type="default" onClick={onCancel} disabled={isSubmitting}>
        {t('clientForm.cancel')}
      </Button>
      <Button type="primary" htmlType="submit" loading={isSubmitting}>
        {submitText || t('clientForm.create')}
      </Button>
    </Container>
  );
}
